<template>
  <div>
    <div class="breadcrumb-section">
      <div class="container">
        <div class="row">
          <div class="col-sm-6">
            <div class="page-title">
              <h2>结算</h2>
            </div>
          </div>
          <div class="col-sm-6">
            <nav aria-label="breadcrumb" class="theme-breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="index.html">主页</a></li>
                <li class="breadcrumb-item active" aria-current="page">结算</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <section class="section-b-space">
      <div class="container">
        <div class="checkout-page">
          <div class="checkout-form">
            <form>
              <div class="row">
                <div class="col-lg-6 col-sm-12 col-xs-12">
                  <div class="checkout-title" v-if="needExpress">
                    <h3>收货地址</h3>
                  </div>
                  <div class="checkout-title" v-else>
                    <h3>收货信息</h3>
                  </div>
                  <div class="row check-out">
                    <div v-if="needExpress">
                      <div class="form-group col-md-6 col-sm-6 col-xs-12">
                        <div class="field-label">Last Name</div>
                        <input type="text" v-model="express.lastname" placeholder="姓">
                      </div>
                      <div class="form-group col-md-6 col-sm-6 col-xs-12">
                        <div class="field-label">First Name</div>
                        <input type="text" v-model="express.firstname" placeholder="名">
                      </div>
                      <div class="form-group col-md-4 col-sm-4 col-xs-12">
                        <div class="field-label">Code</div>
                        <input type="text" v-model="express.mobile_code" value="" placeholder="区号">
                      </div>
                      <div class="form-group col-md-8 col-sm-8 col-xs-12">
                        <div class="field-label">Phone</div>
                        <input type="text" v-model="express.mobile" value="" placeholder="手机号">
                      </div>
                    </div>
                    <div class="form-group col-md-12 col-sm-12 col-xs-12">
                      <div class="field-label">Wechat</div>
                      <input type="text" v-model="express.wechat" placeholder="微信号">
                    </div>
                    <div class="form-group col-md-12 col-sm-12 col-xs-12">
                      <div class="field-label">Email Address</div>
                      <input type="text" v-model="express.email" placeholder="电子邮箱">
                    </div>
                    <div class="form-group col-md-12 col-sm-12 col-xs-12">
                      <div class="field-label">Confirm Email Address </div>
                      <input type="text" v-model="email" placeholder="再次确认电子邮箱，将用于接收支付链接邮件">
                    </div>
                    <div class="form-group col-md-12 col-sm-12 col-xs-12" v-if="!needExpress">
                      <div class="field-label">Coupon Code</div>
                      <input type="text" v-model="couponCode" placeholder="优惠码" @change="handleCouponCode">
                    </div>
                    <div v-if="needExpress">
                      <div class="form-group col-md-12 col-sm-12 col-xs-12">
                        <div class="field-label">Country</div>
                        <select v-model="express.country" @change="getCartTotal">
                          <option>请选择</option>
                          <option v-for="country in countries" :key="country.name">{{ country.name }}</option>
                        </select>
                      </div>
                      <div class="form-group col-md-12 col-sm-12 col-xs-12">
                        <div class="field-label">Address</div>
                        <input type="text" v-model="express.address" value="" placeholder="街道详细地址">
                      </div>
                      <div class="form-group col-md-12 col-sm-12 col-xs-12">
                        <div class="field-label">Town / City</div>
                        <input type="text" v-model="express.city" value="" placeholder="城市">
                      </div>
                      <div class="form-group col-md-12 col-sm-6 col-xs-12">
                        <div class="field-label">State / County</div>
                        <input type="text" v-model="express.province" value="" placeholder="省/地区">
                      </div>
                      <div class="form-group col-md-12 col-sm-6 col-xs-12">
                        <div class="field-label">Postal Code</div>
                        <input type="text" v-model="express.postal" value="" placeholder="邮政编码">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-sm-12 col-xs-12">
                  <div class="checkout-details">
                    <div class="order-box">
                      <div class="title-box">
                        <div>商品 <span>小计</span></div>
                      </div>
                      <ul class="qty">
                        <li v-for="goods in cart" :key="goods.plan.plan_id">{{ (goods.plan.price + goods.service.price) | number('0,0') }} × {{ goods.qty }} <span>￥{{ (goods.plan.price + goods.service.price) * goods.qty | number('0,0') }}</span></li>
                      </ul>
                      <ul class="sub-total">
                        <li>商品合计 <span class="count">￥{{ total | number('0,0') }}</span></li>
                        <li v-if="express.price === 0">邮寄 <span class="count">￥{{ express.price | number('0,0') }} 免邮费</span></li>
                        <li v-else>邮寄 <span class="count">￥{{ express.price | number('0,0') }}</span></li>
                        <li v-if="coupon.amount > 0">优惠 <span class="count">￥{{ coupon.amount | number('0,0') }}</span></li>
                      </ul>
                      <ul class="total">
                        <li>合计 <span class="count">￥{{ total + express.price - parseFloat(coupon.amount) | number('0,0') }}</span></li>
                      </ul>
                    </div>
                    <div class="payment-box">
                      <div class="upper-box">
                        <div class="payment-options">
                          <ul>
                            <li>
                              <div class="radio-option paypal">
                                <input type="radio" name="payment-group" id="payment-3">
                                <label for="payment-3"><span class="image"><img style="max-width: 150px;" src="data:image/png;base64,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" alt=""></span></label>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div class="text-end">
                        <a class="btn-solid btn" @click="addOrder">准备支付</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { getCart } from '@/libs/util'
import { addTicket, checkCoupon } from '@/api/trade'

export default {
  name: 'Checkout',
  data () {
    return {
      isLoading: false,
      needExpress: true,
      total: 0,
      cart: [],
      email: '',
      express: {
        price: 0,
        country: '',
        province: '',
        city: '',
        address: '',
        postal: '',
        lastname: '',
        firstname: '',
        mobile_code: '',
        mobile: '',
        wechat: '',
        email: ''
      },
      retry: 0,
      countries: [],
      countryList: [
        {
          "abbr": "AF",
          "chinese": "阿富汗",
          "code": "93",
          "english": "Afghanistan",
          "spell": "afuhan",
          "state": "亚洲",
          "french": "Afghanistan",
          "italian": "Afghanistan",
          "spanish": "Afganistán",
          "japanese": "アフガニスタン",
          "russian": "Афганистан",
          "germen": "Afghanistan"
        },
        {
          "abbr": "AL",
          "chinese": "阿尔巴尼亚",
          "code": "355",
          "english": "Albania",
          "spell": "aerbaniya",
          "state": "亚洲",
          "french": "Albanie",
          "italian": "Albania",
          "spanish": "Albania",
          "japanese": "アルバニア",
          "russian": "Албания",
          "germen": "Albanien"
        },
        {
          "abbr": "DZ",
          "chinese": "阿尔及利亚",
          "code": "213",
          "english": "Algeria",
          "spell": "aerjiliya",
          "state": "非洲",
          "french": "Algérie",
          "italian": "Algeria",
          "spanish": "Argelia",
          "japanese": "アルジェリア",
          "russian": "Алжир",
          "germen": "Algerien"
        },
        {
          "abbr": "AO",
          "chinese": "安哥拉",
          "code": "244",
          "english": "Angola",
          "spell": "angela",
          "state": "非洲",
          "french": "Angola",
          "italian": "Angola",
          "spanish": "Angola",
          "japanese": "アンゴラ",
          "russian": "Ангола",
          "germen": "Angola"
        },
        {
          "abbr": "AR",
          "chinese": "阿根廷",
          "code": "54",
          "english": "Argentina",
          "spell": "agenting",
          "state": "南美洲",
          "french": "Argentine",
          "italian": "Argentina",
          "spanish": "Argentina",
          "japanese": "アルゼンチン",
          "russian": "Аргентина",
          "germen": "Argentinien"
        },
        {
          "abbr": "AM",
          "chinese": "亚美尼亚",
          "code": "374",
          "english": "Armenia",
          "spell": "yameiniya",
          "french": "Arménie",
          "italian": "Armenia",
          "spanish": "Armenia",
          "japanese": "アルメニア",
          "russian": "Армения",
          "germen": "Armenien"
        },
        {
          "abbr": "AU",
          "chinese": "澳大利亚",
          "code": "61",
          "english": "Australia",
          "spell": "aodaliya",
          "state": "大洋洲",
          "french": "Îles Cocos",
          "italian": "Isole Cocos e Keeling",
          "spanish": "Islas Cocos o Islas Keeling",
          "japanese": "ココス（キーリング）諸島",
          "russian": "Австралия",
          "germen": "Kokosinseln"
        },
        {
          "abbr": "AT",
          "chinese": "奥地利",
          "code": "43",
          "english": "Austria",
          "spell": "aodili",
          "state": "欧洲",
          "french": "Autriche",
          "italian": "Austria",
          "spanish": "Austria",
          "japanese": "オーストリア",
          "russian": "Австрия",
          "germen": "Österreich"
        },
        {
          "abbr": "AZ",
          "chinese": "阿塞拜疆",
          "code": "994",
          "english": "Azerbaijan",
          "spell": "asaibaijiang",
          "state": "亚洲",
          "french": "Azerbaïdjan",
          "italian": "Azerbaijan",
          "spanish": "Azerbaiyán",
          "japanese": "アゼルバイジャン",
          "russian": "Азербайджан",
          "germen": "Aserbaidschan"
        },
        {
          "abbr": "BH",
          "chinese": "巴林",
          "code": "973",
          "english": "Bahrain",
          "spell": "balin",
          "state": "亚洲",
          "french": "Bahreïn",
          "italian": "Bahrein",
          "spanish": "Bahrein",
          "japanese": "バーレーン",
          "russian": "Бахрейн",
          "germen": "Bahrain"
        },
        {
          "abbr": "BD",
          "chinese": "孟加拉国",
          "code": "880",
          "english": "Bangladesh",
          "spell": "mengjialaguo",
          "state": "亚洲",
          "french": "Bangladesh",
          "italian": "Bangladesh",
          "spanish": "Bangladesh",
          "japanese": "バングラデシュ",
          "russian": "Бангладеш",
          "germen": "Bangladesch"
        },
        {
          "abbr": "BY",
          "chinese": "白俄罗斯",
          "code": "375",
          "english": "Belarus",
          "spell": "baieluosi",
          "french": "Biélorussie",
          "italian": "Bielorussia",
          "spanish": "Bielorrusia",
          "japanese": "ベラルーシ",
          "russian": "Белоруссия",
          "germen": "Weißrussland"
        },
        {
          "abbr": "BE",
          "chinese": "比利时",
          "code": "32",
          "english": "Belgium",
          "spell": "bilishi",
          "state": "欧洲",
          "french": "Belgique",
          "italian": "Belgio",
          "spanish": "Bélgica",
          "japanese": "ベルギー",
          "russian": "Бельгия",
          "germen": "Belgien"
        },
        {
          "abbr": "BZ",
          "chinese": "伯利兹",
          "code": "501",
          "english": "Belize",
          "spell": "bolizi",
          "french": "Belize",
          "italian": "Belize",
          "spanish": "Belice",
          "japanese": "ベリーズ",
          "russian": "Белиз",
          "germen": "Belize"
        },
        {
          "abbr": "BJ",
          "chinese": "贝宁",
          "code": "229",
          "english": "Benin",
          "spell": "beining",
          "state": "非洲",
          "french": "Bénin",
          "italian": "Benin",
          "spanish": "Benín",
          "japanese": "ベナン",
          "russian": "Бенин",
          "germen": "Benin"
        },
        {
          "abbr": "BT",
          "chinese": "不丹",
          "code": "975",
          "english": "Bhutan",
          "spell": "budan",
          "state": "亚洲",
          "french": "Bhoutan",
          "italian": "Bhutan",
          "spanish": "Bután",
          "japanese": "ブータン",
          "russian": "Бутан",
          "germen": "Bhutan"
        },
        {
          "abbr": "BO",
          "chinese": "玻利维亚",
          "code": "591",
          "english": "Bolivia",
          "spell": "boliweiya",
          "state": "南美洲",
          "french": "Bolivie",
          "italian": "Bolivia",
          "spanish": "Bolivia",
          "japanese": "ボリビア多民族国",
          "russian": "Боливия",
          "germen": "Bolivien"
        },
        {
          "abbr": "BA",
          "chinese": "波斯尼亚和黑塞哥维那",
          "code": "387",
          "english": "Bosnia and Herzegovina",
          "spell": "bosiniyaheheisaigeweinei",
          "french": "Bosnie-Herzégovine",
          "italian": "Bosnia ed Erzegovina",
          "spanish": "Bosnia y Herzegovina",
          "japanese": "ボスニア・ヘルツェゴビナ",
          "russian": "Босния и Герцеговина",
          "germen": "Bosnien und Herzegowina"
        },
        {
          "abbr": "BW",
          "chinese": "博茨瓦纳",
          "code": "267",
          "english": "Botswana",
          "spell": "bociwana",
          "state": "非洲",
          "french": "Botswana",
          "italian": "Botswana",
          "spanish": "Botswana",
          "japanese": "ボツワナ",
          "russian": "Ботсвана",
          "germen": "Botswana"
        },
        {
          "abbr": "BR",
          "chinese": "巴西",
          "code": "55",
          "english": "Brazil",
          "spell": "baxi",
          "state": "南美洲",
          "french": "Brésil",
          "italian": "Brasile",
          "spanish": "Brasil",
          "japanese": "ブラジル",
          "russian": "Бразилия",
          "germen": "Brasilien"
        },
        {
          "abbr": "VG",
          "chinese": "英属维京群岛",
          "code": "1284",
          "english": "British Virgin Islands",
          "spell": "yingshuweijingqundao",
          "french": "Îles Vierges britanniques",
          "italian": "Isole Vergini Britanniche",
          "spanish": "Islas Vírgenes del Reino Unido",
          "japanese": "イギリス領ヴァージン諸島",
          "russian": "Британские Виргинские острова",
          "germen": "Britische Jungferninseln"
        },
        {
          "abbr": "BN",
          "chinese": "文莱",
          "code": "673",
          "english": "Brunei",
          "spell": "wenlai",
          "state": "亚洲",
          "french": "Brunei",
          "italian": "Brunei",
          "spanish": "Brunei",
          "japanese": "ブルネイ・ダルサラーム",
          "russian": "Bulgaria",
          "germen": "Brunei"
        },
        {
          "abbr": "BG",
          "chinese": "保加利亚",
          "code": "359",
          "english": "Bulgaria",
          "spell": "baojialiya",
          "state": "欧洲",
          "french": "Bulgarie",
          "italian": "Bulgaria",
          "spanish": "Bulgaria",
          "japanese": "ブルガリア",
          "russian": "Болгария",
          "germen": "Bulgarien"
        },
        {
          "abbr": "BF",
          "chinese": "布基纳法索",
          "code": "226",
          "english": "Burkina-faso",
          "spell": "bujinafasuo",
          "french": "Burkina Faso",
          "italian": "Burkina Faso",
          "spanish": "Burkina Faso",
          "japanese": "ブルキナファソ",
          "russian": "Буркина-Фасо",
          "germen": "Burkina Faso"
        },
        {
          "abbr": "BI",
          "chinese": "布隆迪",
          "code": "257",
          "english": "Burundi",
          "spell": "bulongdi",
          "state": "非洲",
          "french": "Burundi",
          "italian": "Burundi",
          "spanish": "Burundi",
          "japanese": "ブルンジ",
          "russian": "Бурунди",
          "germen": "Burundi"
        },
        {
          "abbr": "KH",
          "chinese": "柬埔寨",
          "code": "855",
          "english": "Cambodia",
          "spell": "jianpuzhai",
          "state": "亚洲",
          "french": "Cambodge",
          "italian": "Cambogia",
          "spanish": "Camboya",
          "japanese": "カンボジア",
          "russian": "Камбоджа",
          "germen": "Kambodscha"
        },
        {
          "abbr": "CM",
          "chinese": "喀麦隆",
          "code": "237",
          "english": "Cameroon",
          "spell": "kamailong",
          "state": "非洲",
          "french": "Cameroun",
          "italian": "Camerun",
          "spanish": "Camerún",
          "japanese": "カメルーン",
          "russian": "Камерун",
          "germen": "Kamerun"
        },
        {
          "abbr": "CA",
          "chinese": "加拿大",
          "code": "1",
          "english": "Canada",
          "spell": "jianada",
          "state": "北美洲",
          "french": "États-Unis",
          "italian": "Stati Uniti D\u0027America",
          "spanish": "Estados Unidos",
          "japanese": "アメリカ合衆国",
          "russian": "Канада",
          "germen": "Vereinigte Staaten von Amerika"
        },
        {
          "abbr": "CV",
          "chinese": "佛得角",
          "code": "238",
          "english": "Cape Verde",
          "spell": "fodejiao",
          "state": "非洲",
          "french": "Cap Vert",
          "italian": "Capo Verde",
          "spanish": "Cabo Verde",
          "japanese": "カーボベルデ",
          "russian": "Кабо-Верде",
          "germen": "Kap Verde"
        },
        {
          "abbr": "KY",
          "chinese": "开曼群岛",
          "code": "1345",
          "english": "Cayman Islands",
          "spell": "kaimanqundao",
          "french": "Îles Caïmans",
          "italian": "Isole Cayman",
          "spanish": "Islas Caimán",
          "japanese": "ケイマン諸島",
          "russian": "Каймановы Острова",
          "germen": "Kaimaninseln"
        },
        {
          "abbr": "CF",
          "chinese": "中非共和国",
          "code": "236",
          "english": "Central African Republic",
          "spell": "zhongfeigongheguo",
          "state": "非洲",
          "french": "République centrafricaine",
          "italian": "Repubblica Centrafricana",
          "spanish": "República Centroafricana",
          "japanese": "中央アフリカ共和国",
          "russian": "Центрально-Африканская Республика",
          "germen": "Zentralafrikanische Republik"
        },
        {
          "abbr": "TD",
          "chinese": "乍得",
          "code": "235",
          "english": "Chad",
          "spell": "zhade",
          "french": "Tchad",
          "italian": "Ciad",
          "spanish": "Chad",
          "japanese": "チャド",
          "russian": "Чад",
          "germen": "Tschad"
        },
        {
          "abbr": "CL",
          "chinese": "智利",
          "code": "56",
          "english": "Chile",
          "spell": "zhili",
          "state": "南美洲",
          "french": "Chili",
          "italian": "Cile",
          "spanish": "Chile",
          "japanese": "チリ",
          "russian": "Чили",
          "germen": "Chile"
        },
        {
          "abbr": "CN",
          "chinese": "中国",
          "code": "86",
          "english": "China",
          "spell": "zhongguo",
          "state": "亚洲",
          "french": "Chine",
          "italian": "Cina",
          "spanish": "China",
          "japanese": "中国",
          "russian": "Китай",
          "germen": "China"
        },
        {
          "abbr": "CO",
          "chinese": "哥伦比亚",
          "code": "57",
          "english": "Colombia",
          "spell": "gelunbiya",
          "state": "南美洲",
          "french": "Colombie",
          "italian": "Colombia",
          "spanish": "Colombia",
          "japanese": "コロンビア",
          "russian": "Колумбия",
          "germen": "Kolumbien"
        },
        {
          "abbr": "KM",
          "chinese": "科摩罗",
          "code": "269",
          "english": "Comoros",
          "spell": "kemoluo",
          "french": "Comores",
          "italian": "Comore",
          "spanish": "Comoras",
          "japanese": "コモロ",
          "russian": "Коморские острова",
          "germen": "Union der Komoren"
        },
        {
          "abbr": "CG",
          "chinese": "刚果(布)",
          "code": "242",
          "english": "Congo - Brazzaville",
          "spell": "gangguo(bu)",
          "state": "非洲",
          "french": "Congo",
          "italian": "Congo",
          "spanish": "Congo",
          "japanese": "コンゴ共和国",
          "russian": "Конго - Браззавиль",
          "germen": "Kongo"
        },
        {
          "abbr": "CD",
          "chinese": "刚果(金)",
          "code": "243",
          "english": "Congo - Kinshasa",
          "spell": "gangguo(jin)",
          "french": "Congo (Rép. dém.)",
          "italian": "Congo (Rep. Dem.)",
          "spanish": "Congo (Rep. Dem.)",
          "japanese": "コンゴ民主共和国",
          "russian": "Конго - Киншаса",
          "germen": "Kongo (Dem. Rep.)"
        },
        {
          "abbr": "CR",
          "chinese": "哥斯达黎加",
          "code": "506",
          "english": "Costa Rica",
          "spell": "gesidalijia",
          "state": "北美洲",
          "french": "Costa Rica",
          "italian": "Costa Rica",
          "spanish": "Costa Rica",
          "japanese": "コスタリカ",
          "russian": "Коста-Рика",
          "germen": "Costa Rica"
        },
        {
          "abbr": "HR",
          "chinese": "克罗地亚",
          "code": "385",
          "english": "Croatia",
          "spell": "keluodiya",
          "state": "欧洲",
          "french": "Croatie",
          "italian": "Croazia",
          "spanish": "Croacia",
          "japanese": "クロアチア",
          "russian": "Хорватия",
          "germen": "Kroatien"
        },
        {
          "abbr": "CY",
          "chinese": "塞浦路斯",
          "code": "357",
          "english": "Cyprus",
          "spell": "saipulusi",
          "state": "亚洲",
          "french": "Chypre",
          "italian": "Cipro",
          "spanish": "Chipre",
          "japanese": "キプロス",
          "russian": "Кипр",
          "germen": "Zypern"
        },
        {
          "abbr": "CZ",
          "chinese": "捷克共和国",
          "code": "420",
          "english": "Czech Republic",
          "spell": "jiekegongheguo",
          "state": "欧洲",
          "french": "République tchèque",
          "italian": "Repubblica Ceca",
          "spanish": "República Checa",
          "japanese": "チェコ",
          "russian": "Чехия",
          "germen": "Tschechische Republik"
        },
        {
          "abbr": "DK",
          "chinese": "丹麦",
          "code": "45",
          "english": "Denmark",
          "spell": "danmai",
          "state": "欧洲",
          "french": "Danemark",
          "italian": "Danimarca",
          "spanish": "Dinamarca",
          "japanese": "デンマーク",
          "russian": "Дания",
          "germen": "Dänemark"
        },
        {
          "abbr": "DJ",
          "chinese": "吉布提",
          "code": "253",
          "english": "Djibouti",
          "spell": "jibuti",
          "french": "Djibouti",
          "italian": "Gibuti",
          "spanish": "Yibuti",
          "japanese": "ジブチ",
          "russian": "Джибути",
          "germen": "Dschibuti"
        },
        {
          "abbr": "DO",
          "chinese": "多米尼加共和国",
          "code": "1809",
          "english": "Dominican Republic",
          "spell": "duominijiagongheguo",
          "french": "République dominicaine",
          "italian": "Repubblica Dominicana",
          "spanish": "República Dominicana",
          "japanese": "ドミニカ共和国",
          "russian": "Доминиканская Республика",
          "germen": "Dominikanische Republik"
        },
        {
          "abbr": "EC",
          "chinese": "厄瓜多尔",
          "code": "593",
          "english": "Ecuador",
          "spell": "eguaduoer",
          "state": "南美洲",
          "french": "Équateur",
          "italian": "Ecuador",
          "spanish": "Ecuador",
          "japanese": "エクアドル",
          "russian": "Эквадор",
          "germen": "Ecuador"
        },
        {
          "abbr": "EG",
          "chinese": "埃及",
          "code": "20",
          "english": "Egypt",
          "spell": "aiji",
          "state": "非洲",
          "french": "Égypte",
          "italian": "Egitto",
          "spanish": "Egipto",
          "japanese": "エジプト",
          "russian": "Египет",
          "germen": "Ägypten"
        },
        {
          "abbr": "SV",
          "chinese": "萨尔瓦多",
          "code": "503",
          "english": "EI Salvador",
          "spell": "saerwaduo",
          "french": "Salvador",
          "italian": "El Salvador",
          "spanish": "El Salvador",
          "japanese": "エルサルバドル",
          "russian": "EI Сальвадор",
          "germen": "El Salvador"
        },
        {
          "abbr": "GQ",
          "chinese": "赤道几内亚",
          "code": "240",
          "english": "Equatorial Guinea",
          "spell": "chidaojineiya",
          "state": "非洲",
          "french": "Guinée-Équatoriale",
          "italian": "Guinea Equatoriale",
          "spanish": "Guinea Ecuatorial",
          "japanese": "赤道ギニア",
          "russian": "Экваториальная Гвинея",
          "germen": "Äquatorial-Guinea"
        },
        {
          "abbr": "ER",
          "chinese": "厄立特里亚",
          "code": "291",
          "english": "Eritrea",
          "spell": "eliteliya",
          "french": "Érythrée",
          "italian": "Eritrea",
          "spanish": "Eritrea",
          "japanese": "エリトリア",
          "russian": "Эритрея",
          "germen": "Eritrea"
        },
        {
          "abbr": "EE",
          "chinese": "爱沙尼亚",
          "code": "372",
          "english": "Estonia",
          "spell": "aishaniya",
          "state": "欧洲",
          "french": "Estonie",
          "italian": "Estonia",
          "spanish": "Estonia",
          "japanese": "エストニア",
          "russian": "Эстония",
          "germen": "Estland"
        },
        {
          "abbr": "ET",
          "chinese": "埃塞俄比亚",
          "code": "251",
          "english": "Ethiopia",
          "spell": "aisaiebiya",
          "state": "非洲",
          "french": "Éthiopie",
          "italian": "Etiopia",
          "spanish": "Etiopía",
          "japanese": "エチオピア",
          "russian": "Эфиопия",
          "germen": "Äthiopien"
        },
        {
          "abbr": "FJ",
          "chinese": "斐济",
          "code": "679",
          "english": "Fiji",
          "spell": "feiji",
          "state": "大洋洲",
          "french": "Fidji",
          "italian": "Figi",
          "spanish": "Fiyi",
          "japanese": "フィジー",
          "russian": "Фиджи",
          "germen": "Fidschi"
        },
        {
          "abbr": "FI",
          "chinese": "芬兰",
          "code": "358",
          "english": "Finland",
          "spell": "fenlan",
          "state": "欧洲",
          "french": "Finlande",
          "italian": "Finlandia",
          "spanish": "Finlandia",
          "japanese": "フィンランド",
          "russian": "Финляндия",
          "germen": "Finnland"
        },
        {
          "abbr": "FR",
          "chinese": "法国",
          "code": "33",
          "english": "France",
          "spell": "faguo",
          "state": "欧洲",
          "french": "France",
          "italian": "Francia",
          "spanish": "Francia",
          "japanese": "フランス",
          "russian": "Франция",
          "germen": "Frankreich"
        },
        {
          "abbr": "GA",
          "chinese": "加蓬",
          "code": "241",
          "english": "Gabon",
          "spell": "jiapeng",
          "state": "非洲",
          "french": "Gabon",
          "italian": "Gabon",
          "spanish": "Gabón",
          "japanese": "ガボン",
          "russian": "Габон",
          "germen": "Gabun"
        },
        {
          "abbr": "GM",
          "chinese": "冈比亚",
          "code": "220",
          "english": "Gambia",
          "spell": "gangbiya",
          "state": "非洲",
          "french": "Gambie",
          "italian": "Gambia",
          "spanish": "Gambia",
          "japanese": "ガンビア",
          "russian": "Гамбия",
          "germen": "Gambia"
        },
        {
          "abbr": "GE",
          "chinese": "格鲁吉亚",
          "code": "995",
          "english": "Georgia",
          "spell": "gelujiya",
          "french": "Géorgie",
          "italian": "Georgia",
          "spanish": "Georgia",
          "japanese": "グルジア",
          "russian": "Грузия",
          "germen": "Georgien"
        },
        {
          "abbr": "DE",
          "chinese": "德国",
          "code": "49",
          "english": "Germany",
          "spell": "deguo",
          "state": "欧洲",
          "french": "Allemagne",
          "italian": "Germania",
          "spanish": "Alemania",
          "japanese": "ドイツ",
          "russian": "Германия",
          "germen": "Deutschland"
        },
        {
          "abbr": "GH",
          "chinese": "加纳",
          "code": "233",
          "english": "Ghana",
          "spell": "jiana",
          "state": "非洲",
          "french": "Ghana",
          "italian": "Ghana",
          "spanish": "Ghana",
          "japanese": "ガーナ",
          "russian": "Гана",
          "germen": "Ghana"
        },
        {
          "abbr": "GR",
          "chinese": "希腊",
          "code": "30",
          "english": "Greece",
          "spell": "xila",
          "state": "欧洲",
          "french": "Grèce",
          "italian": "Grecia",
          "spanish": "Grecia",
          "japanese": "ギリシャ",
          "russian": "Греция",
          "germen": "Griechenland"
        },
        {
          "abbr": "GL",
          "chinese": "格陵兰",
          "code": "299",
          "english": "Greenland",
          "spell": "gelinglan",
          "french": "Groenland",
          "italian": "Groenlandia",
          "spanish": "Groenlandia",
          "japanese": "グリーンランド",
          "russian": "Гренландия",
          "germen": "Grönland"
        },
        {
          "abbr": "GT",
          "chinese": "危地马拉",
          "code": "502",
          "english": "Guatemala",
          "spell": "weidimala",
          "state": "北美洲",
          "french": "Guatemala",
          "italian": "Guatemala",
          "spanish": "Guatemala",
          "japanese": "グアテマラ",
          "russian": "Гватемала",
          "germen": "Guatemala"
        },
        {
          "abbr": "GN",
          "chinese": "几内亚",
          "code": "224",
          "english": "Guinea",
          "spell": "jineiya",
          "state": "非洲",
          "french": "Guinée",
          "italian": "Guinea",
          "spanish": "Guinea",
          "japanese": "ギニア",
          "russian": "Гвинея",
          "germen": "Guinea"
        },
        {
          "abbr": "GY",
          "chinese": "圭亚那",
          "code": "592",
          "english": "Guyana",
          "spell": "guiyanei",
          "state": "南美洲",
          "french": "Guyane",
          "italian": "Guyana",
          "spanish": "Guyana",
          "japanese": "ガイアナ",
          "russian": "Гайана",
          "germen": "Guyana"
        },
        {
          "abbr": "HT",
          "chinese": "海地",
          "code": "509",
          "english": "Haiti",
          "spell": "haidi",
          "state": "北美洲",
          "french": "Haïti",
          "italian": "Haiti",
          "spanish": "Haiti",
          "japanese": "ハイチ",
          "russian": "Гаити",
          "germen": "Haiti"
        },
        {
          "abbr": "HN",
          "chinese": "洪都拉斯",
          "code": "504",
          "english": "Honduras",
          "spell": "hongdoulasi",
          "state": "北美洲",
          "french": "Honduras",
          "italian": "Honduras",
          "spanish": "Honduras",
          "japanese": "ホンジュラス",
          "russian": "Гондурас",
          "germen": "Honduras"
        },
        {
          "abbr": "HK",
          "chinese": "中国香港特别行政区",
          "code": "852",
          "english": "Hongkong SAR China",
          "spell": "zhongguoxianggangtebiexingzhengqu",
          "state": "亚洲",
          "french": "Hong Kong",
          "italian": "Hong Kong",
          "spanish": "Hong Kong",
          "japanese": "香港",
          "russian": "Гонконг SAR Китай",
          "germen": "Hong Kong"
        },
        {
          "abbr": "HU",
          "chinese": "匈牙利",
          "code": "36",
          "english": "Hungary",
          "spell": "xiongyali",
          "state": "欧洲",
          "french": "Hongrie",
          "italian": "Ungheria",
          "spanish": "Hungría",
          "japanese": "ハンガリー",
          "russian": "Венгрия",
          "germen": "Ungarn"
        },
        {
          "abbr": "IS",
          "chinese": "冰岛",
          "code": "354",
          "english": "Iceland",
          "spell": "bingdao",
          "state": "欧洲",
          "french": "Islande",
          "italian": "Islanda",
          "spanish": "Islandia",
          "japanese": "アイスランド",
          "russian": "Исландия",
          "germen": "Island"
        },
        {
          "abbr": "IN",
          "chinese": "印度",
          "code": "91",
          "english": "India",
          "spell": "yindu",
          "state": "亚洲",
          "french": "Inde",
          "italian": "India",
          "spanish": "India",
          "japanese": "インド",
          "russian": "Индия",
          "germen": "Indien"
        },
        {
          "abbr": "ID",
          "chinese": "印度尼西亚",
          "code": "62",
          "english": "Indonesia",
          "spell": "yindunixiya",
          "state": "亚洲",
          "french": "Indonésie",
          "italian": "Indonesia",
          "spanish": "Indonesia",
          "japanese": "インドネシア",
          "russian": "Индонезия",
          "germen": "Indonesien"
        },
        {
          "abbr": "IR",
          "chinese": "伊朗",
          "code": "98",
          "english": "Iran",
          "spell": "yilang",
          "state": "亚洲",
          "french": "Iran",
          "italian": "Iran",
          "spanish": "Iran",
          "japanese": "イラン・イスラム共和国",
          "russian": "Иран",
          "germen": "Iran"
        },
        {
          "abbr": "IQ",
          "chinese": "伊拉克",
          "code": "964",
          "english": "Iraq",
          "spell": "yilake",
          "state": "亚洲",
          "french": "Irak",
          "italian": "Iraq",
          "spanish": "Irak",
          "japanese": "イラク",
          "russian": "Ирак",
          "germen": "Irak"
        },
        {
          "abbr": "IE",
          "chinese": "爱尔兰",
          "code": "353",
          "english": "Ireland",
          "spell": "aierlan",
          "state": "欧洲",
          "french": "Irlande",
          "italian": "Irlanda",
          "spanish": "Irlanda",
          "japanese": "アイルランド",
          "russian": "Ирландия",
          "germen": "Irland"
        },
        {
          "abbr": "IM",
          "chinese": "马恩岛",
          "code": "44",
          "english": "Isle of Man",
          "spell": "maendao",
          "french": "Royaume-Uni",
          "italian": "Regno Unito",
          "spanish": "Reino Unido",
          "japanese": "イギリス",
          "russian": "Остров Мэн",
          "germen": "Vereinigtes Königreich"
        },
        {
          "abbr": "IL",
          "chinese": "以色列",
          "code": "972",
          "english": "Israel",
          "spell": "yiselie",
          "state": "亚洲",
          "french": "Israël",
          "italian": "Israele",
          "spanish": "Israel",
          "japanese": "イスラエル",
          "russian": "Израиль",
          "germen": "Israel"
        },
        {
          "abbr": "IT",
          "chinese": "意大利",
          "code": "39",
          "english": "Italy",
          "spell": "yidali",
          "state": "欧洲",
          "french": "Italie",
          "italian": "Italia",
          "spanish": "Italia",
          "japanese": "イタリア",
          "russian": "Италия",
          "germen": "Italien"
        },
        {
          "abbr": "CI",
          "chinese": "科特迪瓦",
          "code": "225",
          "english": "Ivory Coast",
          "spell": "ketediwa",
          "french": "Côte d\u0027Ivoire",
          "italian": "Costa D\u0027Avorio",
          "spanish": "Costa de Marfil",
          "japanese": "コートジボワール",
          "russian": "Кот-д'Ивуар",
          "germen": "Elfenbeinküste"
        },
        {
          "abbr": "JM",
          "chinese": "牙买加",
          "code": "1876",
          "english": "Jamaica",
          "spell": "yamaijia",
          "state": "北美洲",
          "french": "Jamaïque",
          "italian": "Giamaica",
          "spanish": "Jamaica",
          "japanese": "ジャマイカ",
          "russian": "Ямайка",
          "germen": "Jamaika"
        },
        {
          "abbr": "JP",
          "chinese": "日本",
          "code": "81",
          "english": "Japan",
          "spell": "riben",
          "state": "亚洲",
          "french": "Japon",
          "italian": "Giappone",
          "spanish": "Japón",
          "japanese": "日本",
          "russian": "Япония",
          "germen": "Japan"
        },
        {
          "abbr": "JO",
          "chinese": "约旦",
          "code": "962",
          "english": "Jordan",
          "spell": "yuedan",
          "state": "亚洲",
          "french": "Jordanie",
          "italian": "Giordania",
          "spanish": "Jordania",
          "japanese": "ヨルダン",
          "russian": "Иордания",
          "germen": "Jordanien"
        },
        {
          "abbr": "KZ",
          "chinese": "哈萨克斯坦",
          "code": "7",
          "english": "Kazakstan",
          "spell": "hasakesitan",
          "state": "亚洲",
          "french": "Russie",
          "italian": "Russia",
          "spanish": "Rusia",
          "japanese": "ロシア連邦",
          "russian": "Казахстан",
          "germen": "Russland"
        },
        {
          "abbr": "KE",
          "chinese": "肯尼亚",
          "code": "254",
          "english": "Kenya",
          "spell": "kenniya",
          "state": "非洲",
          "french": "Kenya",
          "italian": "Kenya",
          "spanish": "Kenia",
          "japanese": "ケニア",
          "russian": "Кения",
          "germen": "Kenia"
        },
        {
          "abbr": "KR",
          "chinese": "韩国",
          "code": "82",
          "english": "Korea",
          "spell": "hanguo",
          "state": "亚洲",
          "french": "Corée du Sud",
          "italian": "Corea del Sud",
          "spanish": "Corea del Sur",
          "japanese": "大韓民国",
          "russian": "Корея",
          "germen": "Südkorea"
        },
        {
          "abbr": "KW",
          "chinese": "科威特",
          "code": "965",
          "english": "Kuwait",
          "spell": "keweite",
          "state": "亚洲",
          "french": "Koweït",
          "italian": "Kuwait",
          "spanish": "Kuwait",
          "japanese": "クウェート",
          "russian": "Кувейт",
          "germen": "Kuwait"
        },
        {
          "abbr": "KG",
          "chinese": "吉尔吉斯斯坦",
          "code": "996",
          "english": "Kyrgyzstan",
          "spell": "jierjisisitan",
          "french": "Kirghizistan",
          "italian": "Kirghizistan",
          "spanish": "Kirguizistán",
          "japanese": "キルギス",
          "russian": "Киргизия",
          "germen": "Kirgisistan"
        },
        {
          "abbr": "LA",
          "chinese": "老挝",
          "code": "856",
          "english": "Laos",
          "spell": "laowo",
          "state": "亚洲",
          "french": "Laos",
          "italian": "Laos",
          "spanish": "Laos",
          "japanese": "ラオス人民民主共和国",
          "russian": "Лаос",
          "germen": "Laos"
        },
        {
          "abbr": "LV",
          "chinese": "拉脱维亚",
          "code": "371",
          "english": "Latvia",
          "spell": "latuoweiya",
          "state": "欧洲",
          "french": "Lettonie",
          "italian": "Lettonia",
          "spanish": "Letonia",
          "japanese": "ラトビア",
          "russian": "Латвия",
          "germen": "Lettland"
        },
        {
          "abbr": "LB",
          "chinese": "黎巴嫩",
          "code": "961",
          "english": "Lebanon",
          "spell": "libanen",
          "state": "亚洲",
          "french": "Liban",
          "italian": "Libano",
          "spanish": "Líbano",
          "japanese": "レバノン",
          "russian": "Ливан",
          "germen": "Libanon"
        },
        {
          "abbr": "LS",
          "chinese": "莱索托",
          "code": "266",
          "english": "Lesotho",
          "spell": "laisuotuo",
          "french": "Lesotho",
          "italian": "Lesotho",
          "spanish": "Lesotho",
          "japanese": "レソト",
          "russian": "Лесото",
          "germen": "Lesotho"
        },
        {
          "abbr": "LR",
          "chinese": "利比里亚",
          "code": "231",
          "english": "Liberia",
          "spell": "libiliya",
          "french": "Liberia",
          "italian": "Liberia",
          "spanish": "Liberia",
          "japanese": "リベリア",
          "russian": "Либерия",
          "germen": "Liberia"
        },
        {
          "abbr": "LY",
          "chinese": "利比亚",
          "code": "218",
          "english": "Libya",
          "spell": "libiya",
          "state": "非洲",
          "french": "Libye",
          "italian": "Libia",
          "spanish": "Libia",
          "japanese": "リビア",
          "russian": "Ливия",
          "germen": "Libyen"
        },
        {
          "abbr": "LT",
          "chinese": "立陶宛",
          "code": "370",
          "english": "Lithuania",
          "spell": "litaowan",
          "state": "欧洲",
          "french": "Lituanie",
          "italian": "Lituania",
          "spanish": "Lituania",
          "japanese": "リトアニア",
          "russian": "Литва",
          "germen": "Litauen"
        },
        {
          "abbr": "LU",
          "chinese": "卢森堡",
          "code": "352",
          "english": "Luxembourg",
          "spell": "lusenbao",
          "state": "亚洲",
          "french": "Luxembourg",
          "italian": "Lussemburgo",
          "spanish": "Luxemburgo",
          "japanese": "ルクセンブルク",
          "russian": "Люксембург",
          "germen": "Luxemburg"
        },
        {
          "abbr": "MO",
          "chinese": "中国澳门特别行政区",
          "code": "853",
          "english": "Macao SAR China",
          "spell": "zhongguoaomentebiexingzhengqu",
          "state": "亚洲",
          "french": "Macao",
          "italian": "Macao",
          "spanish": "Macao",
          "japanese": "マカオ",
          "russian": "Макао SAR Китай",
          "germen": "Macao"
        },
        {
          "abbr": "MK",
          "chinese": "马其顿",
          "code": "389",
          "english": "Macedonia",
          "spell": "maqidun",
          "french": "Macédoine",
          "italian": "Macedonia",
          "spanish": "Macedonia",
          "japanese": "マケドニア旧ユーゴスラビア共和国",
          "russian": "Македония",
          "germen": "Mazedonien"
        },
        {
          "abbr": "MG",
          "chinese": "马达加斯加",
          "code": "261",
          "english": "Madagascar",
          "spell": "madajiasijia",
          "state": "非洲",
          "french": "Madagascar",
          "italian": "Madagascar",
          "spanish": "Madagascar",
          "japanese": "マダガスカル",
          "russian": "Мадагаскар",
          "germen": "Madagaskar"
        },
        {
          "abbr": "MW",
          "chinese": "马拉维",
          "code": "265",
          "english": "Malawi",
          "spell": "malawei",
          "french": "Malawi",
          "italian": "Malawi",
          "spanish": "Malawi",
          "japanese": "マラウイ",
          "russian": "Малави",
          "germen": "Malawi"
        },
        {
          "abbr": "MY",
          "chinese": "马来西亚",
          "code": "60",
          "english": "Malaysia",
          "spell": "malaixiya",
          "state": "亚洲",
          "french": "Malaisie",
          "italian": "Malesia",
          "spanish": "Malasia",
          "japanese": "マレーシア",
          "russian": "Малайзия",
          "germen": "Malaysia"
        },
        {
          "abbr": "MV",
          "chinese": "马尔代夫",
          "code": "960",
          "english": "Maldives",
          "spell": "maerdaifu",
          "state": "亚洲",
          "french": "Maldives",
          "italian": "Maldive",
          "spanish": "Maldivas",
          "japanese": "モルディブ",
          "russian": "Мальдивы",
          "germen": "Malediven"
        },
        {
          "abbr": "ML",
          "chinese": "马里",
          "code": "223",
          "english": "Mali",
          "spell": "mali",
          "state": "非洲",
          "french": "Mali",
          "italian": "Mali",
          "spanish": "Mali",
          "japanese": "マリ",
          "russian": "Мали",
          "germen": "Mali"
        },
        {
          "abbr": "MT",
          "chinese": "马耳他",
          "code": "356",
          "english": "Malta",
          "spell": "maerta",
          "state": "欧洲",
          "french": "Malte",
          "italian": "Malta",
          "spanish": "Malta",
          "japanese": "マルタ",
          "russian": "Мальта",
          "germen": "Malta"
        },
        {
          "abbr": "MR",
          "chinese": "毛利塔尼亚",
          "code": "222",
          "english": "Mauritania",
          "spell": "maolitaniya",
          "state": "非洲",
          "french": "Mauritanie",
          "italian": "Mauritania",
          "spanish": "Mauritania",
          "japanese": "モーリタニア",
          "russian": "Мавритания",
          "germen": "Mauretanien"
        },
        {
          "abbr": "MU",
          "chinese": "毛里求斯",
          "code": "230",
          "english": "Mauritius",
          "spell": "maoliqiusi",
          "state": "非洲",
          "french": "Île Maurice",
          "italian": "Mauritius",
          "spanish": "Mauricio",
          "japanese": "モーリシャス",
          "russian": "Маврикий",
          "germen": "Mauritius"
        },
        {
          "abbr": "MX",
          "chinese": "墨西哥",
          "code": "52",
          "english": "Mexico",
          "spell": "moxige",
          "state": "北美洲",
          "french": "Mexique",
          "italian": "Messico",
          "spanish": "México",
          "japanese": "メキシコ",
          "russian": "Мексика",
          "germen": "Mexiko"
        },
        {
          "abbr": "MD",
          "chinese": "摩尔多瓦",
          "code": "373",
          "english": "Moldova",
          "spell": "moerduowa",
          "state": "欧洲",
          "french": "Moldavie",
          "italian": "Moldavia",
          "spanish": "Moldavia",
          "japanese": "モルドバ共和国",
          "russian": "Молдавия",
          "germen": "Moldawie"
        },
        {
          "abbr": "MC",
          "chinese": "摩纳哥",
          "code": "377",
          "english": "Monaco",
          "spell": "monage",
          "state": "欧洲",
          "french": "Monaco",
          "italian": "Principato di Monaco",
          "spanish": "Mónaco",
          "japanese": "モナコ",
          "russian": "Монако",
          "germen": "Monaco"
        },
        {
          "abbr": "MN",
          "chinese": "蒙古",
          "code": "976",
          "english": "Mongolia",
          "spell": "menggu",
          "state": "亚洲",
          "french": "Mongolie",
          "italian": "Mongolia",
          "spanish": "Mongolia",
          "japanese": "モンゴル",
          "russian": "Монголия",
          "germen": "Mongolei"
        },
        {
          "abbr": "ME",
          "chinese": "黑山共和国",
          "code": "382",
          "english": "Montenegro",
          "spell": "heishangongheguo",
          "french": "Monténégro",
          "italian": "Montenegro",
          "spanish": "Montenegro",
          "japanese": "モンテネグロ",
          "russian": "Черногория",
          "germen": "Montenegro"
        },
        {
          "abbr": "MA",
          "chinese": "摩洛哥",
          "code": "212",
          "english": "Morocco",
          "spell": "moluoge",
          "state": "非洲",
          "french": "Sahara Occidental",
          "italian": "Sahara Occidentale",
          "spanish": "Sahara Occidental",
          "japanese": "西サハラ",
          "russian": "Марокко",
          "germen": "Westsahara"
        },
        {
          "abbr": "MZ",
          "chinese": "莫桑比克",
          "code": "258",
          "english": "Mozambique",
          "spell": "mosangbike",
          "state": "非洲",
          "french": "Mozambique",
          "italian": "Mozambico",
          "spanish": "Mozambique",
          "japanese": "モザンビーク",
          "russian": "Мозамбик",
          "germen": "Mosambik"
        },
        {
          "abbr": "MM",
          "chinese": "缅甸",
          "code": "95",
          "english": "Myanmar(Burma)",
          "spell": "miandian",
          "french": "Myanmar",
          "italian": "Birmania",
          "spanish": "Myanmar",
          "japanese": "ミャンマー",
          "russian": "Мьянма (Бирма)",
          "germen": "Myanmar"
        },
        {
          "abbr": "NA",
          "chinese": "纳米比亚",
          "code": "264",
          "english": "Namibia",
          "spell": "namibiya",
          "state": "非洲",
          "french": "Namibie",
          "italian": "Namibia",
          "spanish": "Namibia",
          "japanese": "ナミビア",
          "russian": "Намибия",
          "germen": "Namibia"
        },
        {
          "abbr": "NP",
          "chinese": "尼泊尔",
          "code": "977",
          "english": "Nepal",
          "spell": "niboer",
          "state": "亚洲",
          "french": "Népal",
          "italian": "Nepal",
          "spanish": "Nepal",
          "japanese": "ネパール",
          "russian": "Непал",
          "germen": "Népal"
        },
        {
          "abbr": "NL",
          "chinese": "荷兰",
          "code": "31",
          "english": "Netherlands",
          "spell": "helan",
          "state": "欧洲",
          "french": "Pays-Bas",
          "italian": "Paesi Bassi",
          "spanish": "Países Bajos",
          "japanese": "オランダ",
          "russian": "Нидерланды",
          "germen": "Niederlande"
        },
        {
          "abbr": "NZ",
          "chinese": "新西兰",
          "code": "64",
          "english": "New Zealand",
          "spell": "xinxilan",
          "state": "大洋洲",
          "french": "Îles Pitcairn",
          "italian": "Isole Pitcairn",
          "spanish": "Islas Pitcairn",
          "japanese": "ピトケアン",
          "russian": "Новая Зеландия",
          "germen": "Pitcairn"
        },
        {
          "abbr": "NI",
          "chinese": "尼加拉瓜",
          "code": "505",
          "english": "Nicaragua",
          "spell": "nijialagua",
          "state": "北美洲",
          "french": "Nicaragua",
          "italian": "Nicaragua",
          "spanish": "Nicaragua",
          "japanese": "ニカラグア",
          "russian": "Никарагуа",
          "germen": "Nicaragua"
        },
        {
          "abbr": "NE",
          "chinese": "尼日尔",
          "code": "227",
          "english": "Niger",
          "spell": "nirier",
          "state": "非洲",
          "french": "Niger",
          "italian": "Niger",
          "spanish": "Níger",
          "japanese": "ニジェール",
          "russian": "Нигер",
          "germen": "Niger"
        },
        {
          "abbr": "NG",
          "chinese": "尼日利亚",
          "code": "234",
          "english": "Nigeria",
          "spell": "niriliya",
          "state": "非洲",
          "french": "Nigéria",
          "italian": "Nigeria",
          "spanish": "Nigeria",
          "japanese": "ナイジェリア",
          "russian": "Нигерия",
          "germen": "Nigeria"
        },
        {
          "abbr": "KP",
          "chinese": "朝鲜",
          "code": "850",
          "english": "North Korea",
          "spell": "chaoxian",
          "state": "亚洲",
          "french": "Corée du Nord",
          "italian": "Corea del Nord",
          "spanish": "Corea del Norte",
          "japanese": "朝鮮民主主義人民共和国",
          "russian": "Северная Корея",
          "germen": "Nordkorea"
        },
        {
          "abbr": "NO",
          "chinese": "挪威",
          "code": "47",
          "english": "Norway",
          "spell": "nuowei",
          "state": "欧洲",
          "french": "Norvège",
          "italian": "Norvegia",
          "spanish": "Noruega",
          "japanese": "ノルウェー",
          "russian": "Норвегия",
          "germen": "Norwegen"
        },
        {
          "abbr": "OM",
          "chinese": "阿曼",
          "code": "968",
          "english": "Oman",
          "spell": "aman",
          "state": "亚洲",
          "french": "Oman",
          "italian": "oman",
          "spanish": "Omán",
          "japanese": "オマーン",
          "russian": "Оман",
          "germen": "Oman"
        },
        {
          "abbr": "PK",
          "chinese": "巴基斯坦",
          "code": "92",
          "english": "Pakistan",
          "spell": "bajisitan",
          "state": "亚洲",
          "french": "Pakistan",
          "italian": "Pakistan",
          "spanish": "Pakistán",
          "japanese": "パキスタン",
          "russian": "Пакистан",
          "germen": "Pakistan"
        },
        {
          "abbr": "PA",
          "chinese": "巴拿马",
          "code": "507",
          "english": "Panama",
          "spell": "banama",
          "state": "北美洲",
          "french": "Panama",
          "italian": "Panama",
          "spanish": "Panamá",
          "japanese": "パナマ",
          "russian": "Панама",
          "germen": "Panama"
        },
        {
          "abbr": "PY",
          "chinese": "巴拉圭",
          "code": "595",
          "english": "Paraguay",
          "spell": "balagui",
          "state": "南美洲",
          "french": "Paraguay",
          "italian": "Paraguay",
          "spanish": "Paraguay",
          "japanese": "パラグアイ",
          "russian": "Парагвай",
          "germen": "Paraguay"
        },
        {
          "abbr": "PE",
          "chinese": "秘鲁",
          "code": "51",
          "english": "Peru",
          "spell": "milu",
          "state": "南美洲",
          "french": "Pérou",
          "italian": "Perù",
          "spanish": "Perú",
          "japanese": "ペルー",
          "russian": "Перу",
          "germen": "Peru"
        },
        {
          "abbr": "PH",
          "chinese": "菲律宾",
          "code": "63",
          "english": "Philippines",
          "spell": "feilvbin",
          "state": "亚洲",
          "french": "Philippines",
          "italian": "Filippine",
          "spanish": "Filipinas",
          "japanese": "フィリピン",
          "russian": "Филиппины",
          "germen": "Philippinen"
        },
        {
          "abbr": "PL",
          "chinese": "波兰",
          "code": "48",
          "english": "Poland",
          "spell": "bolan",
          "state": "欧洲",
          "french": "Pologne",
          "italian": "Polonia",
          "spanish": "Polonia",
          "japanese": "ポーランド",
          "russian": "Польша",
          "germen": "Polen"
        },
        {
          "abbr": "PT",
          "chinese": "葡萄牙",
          "code": "351",
          "english": "Portugal",
          "spell": "putaoya",
          "state": "欧洲",
          "french": "Portugal",
          "italian": "Portogallo",
          "spanish": "Portugal",
          "japanese": "ポルトガル",
          "russian": "Португалия",
          "germen": "Portugal"
        },
        {
          "abbr": "PR",
          "chinese": "波多黎各",
          "code": "1787",
          "english": "Puerto Rico",
          "spell": "boduolige",
          "french": "Porto Rico",
          "italian": "Porto Rico",
          "spanish": "Puerto Rico",
          "japanese": "プエルトリコ",
          "russian": "Пуэрто-Рико",
          "germen": "Puerto Rico"
        },
        {
          "abbr": "QA",
          "chinese": "卡塔尔",
          "code": "974",
          "english": "Qatar",
          "spell": "kataer",
          "state": "亚洲",
          "french": "Qatar",
          "italian": "Qatar",
          "spanish": "Catar",
          "japanese": "カタール",
          "russian": "Катар",
          "germen": "Katar"
        },
        {
          "abbr": "RE",
          "chinese": "留尼旺",
          "code": "262",
          "english": "Reunion",
          "spell": "liuniwang",
          "french": "Réunion",
          "italian": "Riunione",
          "spanish": "Reunión",
          "japanese": "レユニオン",
          "russian": "воссоединение",
          "germen": "Réunion"
        },
        {
          "abbr": "RO",
          "chinese": "罗马尼亚",
          "code": "40",
          "english": "Romania",
          "spell": "luomaniya",
          "state": "欧洲",
          "french": "Roumanie",
          "italian": "Romania",
          "spanish": "Rumania",
          "japanese": "ルーマニア",
          "russian": "Румыния",
          "germen": "Rumänien"
        },
        {
          "abbr": "RU",
          "chinese": "俄罗斯",
          "code": "7",
          "english": "Russia",
          "spell": "eluosi",
          "state": "欧洲",
          "french": "Russie",
          "italian": "Russia",
          "spanish": "Rusia",
          "japanese": "ロシア連邦",
          "russian": "Россия",
          "germen": "Russland"
        },
        {
          "abbr": "RW",
          "chinese": "卢旺达",
          "code": "250",
          "english": "Rwanda",
          "spell": "luwangda",
          "state": "非洲",
          "french": "Rwanda",
          "italian": "Ruanda",
          "spanish": "Ruanda",
          "japanese": "ルワンダ",
          "russian": "Руанда",
          "germen": "Ruanda"
        },
        {
          "abbr": "SM",
          "chinese": "圣马力诺",
          "code": "378",
          "english": "San Marino",
          "spell": "shengmalinuo",
          "state": "欧洲",
          "french": "Saint-Marin",
          "italian": "San Marino",
          "spanish": "San Marino",
          "japanese": "サンマリノ",
          "russian": "Сан-Марино",
          "germen": "San Marino"
        },
        {
          "abbr": "SA",
          "chinese": "沙特阿拉伯",
          "code": "966",
          "english": "Saudi Arabia",
          "spell": "shatealabo",
          "state": "亚洲",
          "french": "Arabie Saoudite",
          "italian": "Arabia Saudita",
          "spanish": "Arabia Saudí",
          "japanese": "サウジアラビア",
          "russian": "Саудовская Аравия",
          "germen": "Saudi-Arabien"
        },
        {
          "abbr": "SN",
          "chinese": "塞内加尔",
          "code": "221",
          "english": "Senegal",
          "spell": "saineijiaer",
          "state": "非洲",
          "french": "Sénégal",
          "italian": "Senegal",
          "spanish": "Senegal",
          "japanese": "セネガル",
          "russian": "Сенегал",
          "germen": "Senegal"
        },
        {
          "abbr": "RS",
          "chinese": "塞尔维亚",
          "code": "381",
          "english": "Serbia",
          "spell": "saierweiya",
          "french": "Serbie",
          "italian": "Serbia",
          "spanish": "Serbia",
          "japanese": "セルビア",
          "russian": "Сербия",
          "germen": "Serbien"
        },
        {
          "abbr": "SL",
          "chinese": "塞拉利昂",
          "code": "232",
          "english": "Sierra Leone",
          "spell": "sailaliang",
          "french": "Sierra Leone",
          "italian": "Sierra Leone",
          "spanish": "Sierra Leone",
          "japanese": "シエラレオネ",
          "russian": "Сьерра-Леоне",
          "germen": "Sierra Leone"
        },
        {
          "abbr": "SG",
          "chinese": "新加坡",
          "code": "65",
          "english": "Singapore",
          "spell": "xinjiapo",
          "state": "亚洲",
          "french": "Singapour",
          "italian": "Singapore",
          "spanish": "Singapur",
          "japanese": "シンガポール",
          "russian": "Сингапур",
          "germen": "Singapur"
        },
        {
          "abbr": "SK",
          "chinese": "斯洛伐克",
          "code": "421",
          "english": "Slovakia",
          "spell": "siluofake",
          "state": "欧洲",
          "french": "Slovaquie",
          "italian": "Slovacchia",
          "spanish": "República Eslovaca",
          "japanese": "スロバキア",
          "russian": "Словакия",
          "germen": "Slowakei"
        },
        {
          "abbr": "SI",
          "chinese": "斯洛文尼亚",
          "code": "386",
          "english": "Slovenia",
          "spell": "siluowenniya",
          "french": "Slovénie",
          "italian": "Slovenia",
          "spanish": "Eslovenia",
          "japanese": "スロベニア",
          "russian": "Словения",
          "germen": "Slowenien"
        },
        {
          "abbr": "SO",
          "chinese": "索马里",
          "code": "252",
          "english": "Somalia",
          "spell": "suomali",
          "state": "非洲",
          "french": "Somalie",
          "italian": "Somalia",
          "spanish": "Somalia",
          "japanese": "ソマリア",
          "russian": "Сомали",
          "germen": "Somalia"
        },
        {
          "abbr": "ZA",
          "chinese": "南非",
          "code": "27",
          "english": "South Africa",
          "spell": "nanfei",
          "state": "非洲",
          "french": "Afrique du Sud",
          "italian": "Sud Africa",
          "spanish": "República de Sudáfrica",
          "japanese": "南アフリカ",
          "russian": "Южно-Африканская Республика (ЮАР)",
          "germen": "Republik Südafrika"
        },
        {
          "abbr": "ES",
          "chinese": "西班牙",
          "code": "34",
          "english": "Spain",
          "spell": "xibanya",
          "state": "欧洲",
          "french": "Espagne",
          "italian": "Spagna",
          "spanish": "España",
          "japanese": "スペイン",
          "russian": "Испания",
          "germen": "Spanien"
        },
        {
          "abbr": "LK",
          "chinese": "斯里兰卡",
          "code": "94",
          "english": "Sri Lanka",
          "spell": "sililanka",
          "french": "Sri Lanka",
          "italian": "Sri Lanka",
          "spanish": "Sri Lanka",
          "japanese": "スリランカ",
          "russian": "Шри-Ланка",
          "germen": "Sri Lanka"
        },
        {
          "abbr": "SD",
          "chinese": "苏丹",
          "code": "249",
          "english": "Sudan",
          "spell": "sudan",
          "state": "非洲",
          "french": "Soudan",
          "italian": "Sudan",
          "spanish": "Sudán",
          "japanese": "スーダン",
          "russian": "Судан",
          "germen": "Sudan"
        },
        {
          "abbr": "SR",
          "chinese": "苏里南",
          "code": "597",
          "english": "Suriname",
          "spell": "sulinan",
          "french": "Surinam",
          "italian": "Suriname",
          "spanish": "Surinam",
          "japanese": "スリナム",
          "russian": "Суринам",
          "germen": "Suriname"
        },
        {
          "abbr": "SZ",
          "chinese": "斯威士兰",
          "code": "268",
          "english": "Swaziland",
          "spell": "siweishilan",
          "french": "Swaziland",
          "italian": "Swaziland",
          "spanish": "Suazilandia",
          "japanese": "スワジランド",
          "russian": "Свазиленд",
          "germen": "Swasiland"
        },
        {
          "abbr": "SE",
          "chinese": "瑞典",
          "code": "46",
          "english": "Sweden",
          "spell": "ruidian",
          "state": "欧洲",
          "french": "Suède",
          "italian": "Svezia",
          "spanish": "Suecia",
          "japanese": "スウェーデン",
          "russian": "Швеция",
          "germen": "Schweden"
        },
        {
          "abbr": "CH",
          "chinese": "瑞士",
          "code": "41",
          "english": "Switzerland",
          "spell": "ruishi",
          "state": "欧洲",
          "french": "Suisse",
          "italian": "Svizzera",
          "spanish": "Suiza",
          "japanese": "スイス",
          "russian": "Швейцария",
          "germen": "Schweiz"
        },
        {
          "abbr": "SY",
          "chinese": "叙利亚",
          "code": "963",
          "english": "Syria",
          "spell": "xuliya",
          "state": "亚洲",
          "french": "Syrie",
          "italian": "Siria",
          "spanish": "Siria",
          "japanese": "シリア・アラブ共和国",
          "russian": "Сирия",
          "germen": "Syrien"
        },
        {
          "abbr": "TW",
          "chinese": "中国台湾",
          "code": "886",
          "english": "Taiwan",
          "spell": "zhongguotaiwan",
          "state": "亚洲",
          "french": "Taïwan",
          "italian": "Taiwan",
          "spanish": "Taiwán",
          "japanese": "台湾（中華民国）",
          "russian": "Тайвань",
          "germen": "Taiwan"
        },
        {
          "abbr": "TJ",
          "chinese": "塔吉克斯坦",
          "code": "992",
          "english": "Tajikstan",
          "spell": "tajikesitan",
          "state": "亚洲",
          "french": "Tadjikistan",
          "italian": "Tagikistan",
          "spanish": "Tayikistán",
          "japanese": "タジキスタン",
          "russian": "Таджикистан",
          "germen": "Tadschikistan"
        },
        {
          "abbr": "TZ",
          "chinese": "坦桑尼亚",
          "code": "255",
          "english": "Tanzania",
          "spell": "tansangniya",
          "state": "非洲",
          "french": "Tanzanie",
          "italian": "Tanzania",
          "spanish": "Tanzania",
          "japanese": "タンザニア",
          "russian": "Танзания",
          "germen": "Tansania"
        },
        {
          "abbr": "TH",
          "chinese": "泰国",
          "code": "66",
          "english": "Thailand",
          "spell": "taiguo",
          "state": "亚洲",
          "french": "Thaïlande",
          "italian": "Tailandia",
          "spanish": "Tailandia",
          "japanese": "タイ",
          "russian": "Таиланд",
          "germen": "Thailand"
        },
        {
          "abbr": "TG",
          "chinese": "多哥",
          "code": "228",
          "english": "Togo",
          "spell": "duoge",
          "french": "Togo",
          "italian": "Togo",
          "spanish": "Togo",
          "japanese": "トーゴ",
          "russian": "Того",
          "germen": "Togo"
        },
        {
          "abbr": "TO",
          "chinese": "汤加",
          "code": "676",
          "english": "Tonga",
          "spell": "tangjia",
          "state": "大洋洲",
          "french": "Tonga",
          "italian": "Tonga",
          "spanish": "Tonga",
          "japanese": "トンガ",
          "russian": "Тонга",
          "germen": "Tonga"
        },
        {
          "abbr": "TT",
          "chinese": "特立尼达和多巴哥",
          "code": "1868",
          "english": "Trinidad and Tobago",
          "spell": "telinidaheduobage",
          "french": "Trinité et Tobago",
          "italian": "Trinidad e Tobago",
          "spanish": "Trinidad y Tobago",
          "japanese": "トリニダード・トバゴ",
          "russian": "Тринидад и Тобаго",
          "germen": "Trinidad und Tobago"
        },
        {
          "abbr": "TN",
          "chinese": "突尼斯",
          "code": "216",
          "english": "Tunisia",
          "spell": "tunisi",
          "state": "非洲",
          "french": "Tunisie",
          "italian": "Tunisia",
          "spanish": "Túnez",
          "japanese": "チュニジア",
          "russian": "Тунис",
          "germen": "Tunesien"
        },
        {
          "abbr": "TR",
          "chinese": "土耳其",
          "code": "90",
          "english": "Turkey",
          "spell": "tuerqi",
          "french": "Turquie",
          "italian": "Turchia",
          "spanish": "Turquía",
          "japanese": "トルコ",
          "russian": "Турция",
          "germen": "Türkei"
        },
        {
          "abbr": "TM",
          "chinese": "土库曼斯坦",
          "code": "993",
          "english": "Turkmenistan",
          "spell": "tukumansitan",
          "state": "亚洲",
          "french": "Turkménistan",
          "italian": "Turkmenistan",
          "spanish": "Turkmenistán",
          "japanese": "トルクメニスタン",
          "russian": "Туркменистан",
          "germen": "Turkmenistan"
        },
        {
          "abbr": "VI",
          "chinese": "美属维尔京群岛",
          "code": "1340",
          "english": "U.S. Virgin Islands",
          "spell": "meishuweierjingqundao",
          "french": "Îles Vierges américaines",
          "italian": "Isole Vergini americane",
          "spanish": "Islas Vírgenes de EE.UU",
          "japanese": "米領バージン諸島",
          "russian": "Виргинские острова США",
          "germen": "US Jungferninseln"
        },
        {
          "abbr": "UG",
          "chinese": "乌干达",
          "code": "256",
          "english": "Uganda",
          "spell": "wuganda",
          "state": "非洲",
          "french": "Uganda",
          "italian": "Uganda",
          "spanish": "Uganda",
          "japanese": "ウガンダ",
          "russian": "Уганда",
          "germen": "Uganda"
        },
        {
          "abbr": "UA",
          "chinese": "乌克兰",
          "code": "380",
          "english": "Ukraine",
          "spell": "wukelan",
          "state": "欧洲",
          "french": "Ukraine",
          "italian": "Ucraina",
          "spanish": "Ucrania",
          "japanese": "ウクライナ",
          "russian": "Украина",
          "germen": "Ukraine"
        },
        {
          "abbr": "AE",
          "chinese": "阿拉伯联合酋长国",
          "code": "971",
          "english": "United Arab Emirates",
          "spell": "alabolianheqiuzhangguo",
          "state": "亚洲",
          "french": "Émirats arabes unis",
          "italian": "Emirati Arabi Uniti",
          "spanish": "Emiratos Árabes Unidos",
          "japanese": "アラブ首長国連邦",
          "russian": "Объединённые Арабские Эмираты (ОАЭ)",
          "germen": "Vereinigte Arabische Emirate"
        },
        {
          "abbr": "GB",
          "chinese": "英国",
          "code": "44",
          "english": "United Kiongdom",
          "spell": "yingguo",
          "state": "欧洲",
          "french": "Royaume-Uni",
          "italian": "Regno Unito",
          "spanish": "Reino Unido",
          "japanese": "イギリス",
          "russian": "Объединенное Королевство",
          "germen": "Vereinigtes Königreich"
        },
        {
          "abbr": "US",
          "chinese": "美国",
          "code": "1",
          "english": "USA",
          "spell": "meiguo",
          "state": "北美洲",
          "french": "États-Unis",
          "italian": "Stati Uniti D\u0027America",
          "spanish": "Estados Unidos",
          "japanese": "アメリカ合衆国",
          "russian": "Соединенные Штаты Америки",
          "germen": "Vereinigte Staaten von Amerika"
        },
        {
          "abbr": "UY",
          "chinese": "乌拉圭",
          "code": "598",
          "english": "Uruguay",
          "spell": "wulagui",
          "state": "南美洲",
          "french": "Uruguay",
          "italian": "Uruguay",
          "spanish": "Uruguay",
          "japanese": "ウルグアイ",
          "russian": "Уругвай",
          "germen": "Uruguay"
        },
        {
          "abbr": "UZ",
          "chinese": "乌兹别克斯坦",
          "code": "998",
          "english": "Uzbekistan",
          "spell": "wuzibiekesitan",
          "state": "亚洲",
          "french": "Ouzbékistan",
          "italian": "Uzbekistan",
          "spanish": "Uzbekistán",
          "japanese": "ウズベキスタン",
          "russian": "Узбекистан",
          "germen": "Usbekistan"
        },
        {
          "abbr": "VA",
          "chinese": "梵蒂冈城",
          "code": "379",
          "english": "Vatican City",
          "spell": "fandigangcheng",
          "state": "欧洲",
          "french": "voir Saint",
          "italian": "Santa Sede",
          "spanish": "Santa Sede",
          "japanese": "聖座",
          "russian": "Ватикан",
          "germen": "Heiliger Stuhl"
        },
        {
          "abbr": "VE",
          "chinese": "委内瑞拉",
          "code": "58",
          "english": "Venezuela",
          "spell": "weineiruila",
          "state": "北美洲",
          "french": "Venezuela",
          "italian": "Venezuela",
          "spanish": "Venezuela",
          "japanese": "ベネズエラ・ボリバル共和国",
          "russian": "Венесуэла",
          "germen": "Venezuela"
        },
        {
          "abbr": "VN",
          "chinese": "越南",
          "code": "84",
          "english": "Vietnam",
          "spell": "yuenan",
          "state": "亚洲",
          "french": "Viêt Nam",
          "italian": "Vietnam",
          "spanish": "Vietnam",
          "japanese": "ベトナム",
          "russian": "Вьетнам",
          "germen": "Vietnam"
        },
        {
          "abbr": "YE",
          "chinese": "也门",
          "code": "967",
          "english": "Yemen",
          "spell": "yemen",
          "state": "亚洲",
          "french": "Yémen",
          "italian": "Yemen",
          "spanish": "Yemen",
          "japanese": "イエメン",
          "russian": "Йемен",
          "germen": "Jemen"
        },
        {
          "abbr": "YU",
          "chinese": "南斯拉夫",
          "code": "381",
          "english": "Yugoslavia",
          "spell": "nansilafu",
          "state": "欧洲",
          "french": "Serbie",
          "italian": "Serbia",
          "spanish": "Serbia",
          "japanese": "セルビア",
          "russian": "Югославия",
          "germen": "Serbien"
        },
        {
          "abbr": "ZR",
          "chinese": "扎伊尔",
          "code": "243",
          "english": "Zaire",
          "spell": "zhayier",
          "state": "非洲",
          "french": "Congo (Rép. dém.)",
          "italian": "Congo (Rep. Dem.)",
          "spanish": "Congo (Rep. Dem.)",
          "japanese": "コンゴ民主共和国",
          "russian": "Заир",
          "germen": "Kongo (Dem. Rep.)"
        },
        {
          "abbr": "ZM",
          "chinese": "赞比亚",
          "code": "260",
          "english": "Zambia",
          "spell": "zanbiya",
          "state": "非洲",
          "french": "Zambie",
          "italian": "Zambia",
          "spanish": "Zambia",
          "japanese": "ザンビア",
          "russian": "Замбия",
          "germen": "Sambia"
        },
        {
          "abbr": "ZW",
          "chinese": "津巴布韦",
          "code": "263",
          "english": "Zimbabwe",
          "spell": "jinbabuwei",
          "state": "非洲",
          "french": "Zimbabwe",
          "italian": "Zimbabwe",
          "spanish": "Zimbabue",
          "japanese": "ジンバブエ",
          "russian": "Зимбабве",
          "germen": "Simbabwe"
        }],
      couponCode: '',
      coupon: {
        status: '',
        amount: 0
      }
    }
  },
  methods: {
    getCart () {
      this.cart = getCart()
      if (this.cart.length === 0) {
        this.$message.info('请先添加购物车')
        location.href = '/#/product'
      }
    },
    handleCouponCode (e) {
      const code = e.target._value.trim()
      setTimeout(() => {
        this.couponCode = code
        this.coupon = {
          status: '',
          amount: 0
        }
        if (this.couponCode.length === 12) {
          checkCoupon({
            coupon_code: this.couponCode
          }).then(res => {
            if (res.code !== 200) {
              this.coupon.status = -1
              this.$message.info(res.msg)
              return false
            }
            this.coupon = res.result
          })
        }
      }, 100)
    },
    getCartTotal () {
      this.total = 0
      this.cart.forEach(v => {
        this.total += (v.plan.price + v.service.price) * v.qty
      })
      // if (this.total >= 1500 || this.express.country === 'China（中国）') {
      //   this.express.price = 0
      // } else {
      // }
      if (this.express.country === 'China（中国）') {
        this.express.price = 0
      } else if (this.express.country === 'Taiwan（中国台湾）') {
        this.express.price = 80
      } else if (this.express.country === 'Hongkong SAR China（中国香港特别行政区）') {
        this.express.price = 50
      } else if (this.express.country === 'Macao SAR China（中国澳门特别行政区）') {
        this.express.price = 50
      } else {
        this.express.price = 300
      }
      console.log(this.express.country, this.express.price)
      this.cart.forEach(v => {
        if (v.service.service_id === 'trial') {
          this.express.price = 0
        } else if (/desk_token_/.test(v.plan.plan_id)) {
          this.express.price = 0
          this.needExpress = false
          this.express.country = 'China（中国）'
        }
      })
    },
    getCountry () {
      this.countries = []
      this.countryList.forEach(v => {
        this.countries.push({
          code: v.code,
          name: v.english +'（' + v.chinese + '）'
        })
      })
    },
    addTicket () {
      if (this.isLoading) {
        this.$message.info('正在生成订单，请稍后')
        return false
      }
      this.isLoading = true
      addTicket({
        express: this.express,
        cart: this.cart,
        coupon_code: this.couponCode
      }).then(res => {
        this.isLoading = false
        if (res.code !== 200) {
          this.$message.info(res.msg)
          return false
        }
        location.href = '/#/order/' + res.result.ticket_id
      })
    },
    addOrder () {
      if (this.needExpress) {
        if (this.express.lastname.trim().length === 0) {
          this.express.lastname = this.express.lastname.trim()
          this.$message.info('请输入姓')
          return false
        }
        if (this.express.firstname.trim().length === 0) {
          this.express.firstname = this.express.firstname.trim()
          this.$message.info('请输入名')
          return false
        }
        if (this.express.mobile_code.trim().length === 0) {
          this.express.mobile_code = this.express.mobile_code.trim()
          this.$message.info('请输入区号')
          return false
        }
        if (this.express.mobile.trim().length === 0) {
          this.express.mobile = this.express.mobile.trim()
          this.$message.info('请输入手机号')
          return false
        }
      }
      if (this.express.wechat.trim().length === 0) {
        this.express.wechat = this.express.wechat.trim()
        this.$message.info('请输入微信号方便客服与您联系')
        return false
      }
      if (this.express.email.trim().length === 0) {
        this.express.email = this.express.email.trim()
        this.$message.info('请输入电子邮箱')
        return false
      }
      if (this.express.email !== this.email) {
        this.$message.info('请电子邮箱是否正确')
        return false
      }
      if (this.couponCode !== '') {
        if (this.coupon.status === -1) {
          this.$message.info('优惠码不可用')
          return false
        }
      }
      if (this.needExpress) {
        if (this.express.country.trim().length === 0) {
          this.$message.info('请选择国家（地区）')
          return false
        }
        if (this.express.address.trim().length === 0) {
          this.$message.info('请输入详细地址')
          return false
        }
        if (this.express.city.trim().length === 0) {
          this.$message.info('请输入城市')
          return false
        }
        if (this.express.province.trim().length === 0) {
          this.$message.info('请输入省/地区')
          return false
        }
        if (this.express.postal.trim().length === 0) {
          this.$message.info('请输入邮政编码')
          return false
        }
      }
      this.retry++
      this.addTicket()
    }
  },
  mounted () {
    this.getCart()
    this.getCartTotal()
    this.getCountry()
    setTimeout(() => {
      this.express.email = this.$parent.user.email
      this.email = this.$parent.user.email
    }, 1000)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Checkout.vue